import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  spacing8,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import {
  FLEX_SPACE_DISTRIBUTE,
  FLEX_SPACE_APART,
  ContentFlexAlignment,
} from 'global/constants';
import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { ComponentViewWrapper } from '../components-view-wrapper.style';

type ColumnsContainerProps = {
  $colours?: ColourItem | null;
  $showBackground?: boolean;
  $showBorder?: boolean;
  $marginBottom?: number;
  $turnOffResponsive?: boolean;
};

export const ColumnsPrintContainer = styled.div<ColumnsContainerProps>`
  border-radius: ${rem(borderRadius8)};
  display: flex;
  margin-left: -${rem(spacing8)};
  margin-right: -${rem(spacing8)};
  margin-bottom: ${({ $marginBottom = spacing24 }) => rem($marginBottom)};

  ${({ $showBorder, $showBackground }) =>
    ($showBorder || $showBackground) &&
    `
    margin-left: 0;
    margin-right: 0;
    padding: ${rem(spacing8)} 0;
  `}

  ${({ $colours, $showBackground }) =>
    $colours &&
    $showBackground &&
    `
    background-color: ${$colours.colour1};
  `}

  ${({ $colours, $showBorder }) =>
    $colours &&
    $showBorder &&
    `
    border: 1px solid ${$colours.colour3};
  `}
`;

export const ColumnPrintWrapper = styled.div`
  border-radius: ${rem(borderRadius8)};

  ${ComponentViewWrapper}:last-child {
    margin-bottom: 0;
  }
`;

type ColumnsColumnProps = {
  $colspan: number;
  $alignment: ContentFlexAlignment;
} & ColumnsContainerProps;

export const ColumnsPrintColumn = styled.div<ColumnsColumnProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(spacing16)};
  justify-content: ${({ $alignment }) => $alignment};
  padding: 0 ${rem(spacing8)};
  margin-bottom: 0;
  width: ${({ $colspan }) => ($colspan / 12) * 100}%;

  ${({ $alignment }) =>
    $alignment === FLEX_SPACE_DISTRIBUTE &&
    `
    ${ColumnPrintWrapper} {
      display: flex;
      flex-direction: column;
      height: 100%;
      & > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  `};

  ${({ $alignment }) =>
    $alignment === FLEX_SPACE_APART &&
    `
      ${ColumnPrintWrapper} {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
      }
  `};

  ${({ $showBorder, $showBackground }) =>
    ($showBorder || $showBackground) &&
    `
    ${ColumnPrintWrapper} {
      padding: ${rem(spacing8)}
    }
  `}

  ${({ $colours, $showBackground }) =>
    $colours &&
    $showBackground &&
    `
    ${ColumnPrintWrapper} {
      background-color: ${$colours.colour1};
    }
  `}

  ${({ $colours, $showBorder }) =>
    $colours &&
    $showBorder &&
    `
    ${ColumnPrintWrapper} {
      border: 1px solid ${$colours.colour3};
    }
  `}
`;
